import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

export const initializeLogRocket = () => {
  const options = {
    release: process.env.npm_package_version,
    network: {
      isEnabled: true,
    },
  };

  LogRocket.init('rastech/front-end', options);
  setupLogRocketReact(LogRocket);
};

export const identifyUser = (userId: string, name: string) => {
  LogRocket.identify(userId, {
    name,
  });
};

const blackList = ['11', '303', '544', '1677'];

export const userIsNotAdmin = (userId: string) =>
  !blackList.find((adminId) => adminId === userId);
// export const toUseLogRocket =
//   'Uncomment above lines and componentDidMount in App.tsx';
